<template>
    <div>
        <Label for="new-name-text">{{resource('IOFormatListViewModel_Name_DisplayName')}} *</Label>
        <div>
            <input id="new-name-text" name="Name" type="text" class="form-control" v-model="newName" @blur="$v.name.$touch()"/>
            <required fieldName="Name" v-if="showError"/>
        </div>
        
        <label for="new-import-checkbox">{{resource('IOFormatListViewModel_Import_DisplayName')}}</label>
        <dnx-checkbox v-model="newImport" id="new-import-checkbox"/>
        
        <label for="new-export-checkbox">{{resource('IOFormatListViewModel_Export_DisplayName')}}</label>
        <dnx-checkbox v-model="newExport" id="new-export-checkbox"/>
        
        <slot></slot>
    
    </div>
    
</template>

<script>

import {elements} from 'dnx-design';
import resources from '../../../../Util/Mixins/resources';
import { validationMixin  } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import RequiredErrorMessage from '../../../../Components/Errors/RequiredErrorMessage.vue';

export default {
    name: 'base-format',
    mixins: [validationMixin, resources],
    components: {
        'Required': RequiredErrorMessage,
        'dnx-checkbox': elements.Checkbox
    },
    methods: {
        resetValidation() {
            this.$v.$reset();
        }
    },
    computed: {
        newName: {
            get() {
                return this.name;
            },
            set(value) {
                this.$v.name.$touch();
                this.$emit('update:name', value);
            }
        },
        newImport: {
            get() {
                return this.isImport;
            },
            set(value) {
                this.$emit('update:isImport', value);
            }
        },
        newExport: {
            get() {
                return this.isExport;
            },
            set(value) {
                this.$emit('update:isExport', value);
            }
        },
        showError() {
            return !this.isValid && this.$v.name.$dirty
        },
        isValid() {
            return this.$v.name.required;
        }
    },
    validations: {
        name: {
            required
        }
    },
    watch: {
        isValid(value) {
            this.$emit('valid', value);
        }
    },
    props: {
        type: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            default: ''
        },
        isExport: {
            type: Boolean,
            default: false
        },
        isImport: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped src="../../Style/create.scss">

</style>